import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { Navigation } from '@app/navigation/enums/navigation.enum';
import { AppUiSandbox } from '@app/ui/sandboxes/ui.sandbox';
import { TelecomSandbox } from '@app/wizard/telecom/sandboxes/telecom.sandbox';

@Component({
    selector: 'app-complete-data-telecom',
    template: `
        <div class="u-flex-column" [ngSwitch]="moveSandbox.telecomComplete$ | async">
            <div class="u-flex-row">
    <div class="u-flex-no-shrink u-margin-right">
        <img class="__image" src="assets/images/smooved-telecom.png" />
    </div>
    <div>
        <div class="u-flex-row u-flex-align-items-center u-margin-bottom-half">
            <h4>{{ 'DASHBOARD.COMPLETE_DATA.TELECOM.TITLE' | translate }}</h4>
            <app-check-with-background
                *ngSwitchCase="true"
                height="20"
                width="20"
                class="u-margin-left-half"
            ></app-check-with-background>
        </div>
        <ul class="u-margin-bottom">
            <li
                [ngClass]="{ 'u-color-muted': !!(moveSandbox.telecomInstallationComplete$ | async) }"
                class="u-font-size-small u-margin-bottom-half"
            >
                {{ 'DASHBOARD.COMPLETE_DATA.TELECOM.TELECOM_INSTALLATION' | translate }}
            </li>
            <li
                *ngIf="(moveSandbox.hasMobilePhone$ | async) || (moveSandbox.hasFixedLine$ | async)"
                [ngClass]="{ 'u-color-muted': !!(moveSandbox.mobileBundleComplete$ | async) }"
                class="u-font-size-small"
            >
                {{ 'DASHBOARD.COMPLETE_DATA.TELECOM.SIM_CARD' | translate }}
            </li>
        </ul>

        <!-- Telecom Installation Date Show/Hide Logic -->
        <ng-container *ngIf="{ move: (moveSandbox.move$ | async), telecomInstallation: (moveSandbox.telecomInstallation$ | async) } as vm">
            <div *ngIf="!!vm.telecomInstallation" class="u-margin-bottom">
                <div class="__label" *ngIf="!(moveSandbox.telecomInstallationDateByAdmin$ | async); else noInstallationDateByAdmin">
                    {{ 'DASHBOARD.TELECOM_INSTALLATION.REQUESTED' | translate }}
                </div>
                <ng-template #noInstallationDateByAdmin>
                    <div class="__label">{{ 'DASHBOARD.TELECOM_INSTALLATION.CONFIRMED' | translate }}</div>
                </ng-template>
                <div class="__date" [ngClass]="{ 'u-text-line-through': !!telecomSandbox.validateNewTelecomSchedule(vm.move) }">
                    ({{ vm.telecomInstallation?.date | formatDate }} - {{ vm.telecomInstallation?.timeSlot }})
                </div>
                <div class="__date" *ngIf="!!telecomSandbox.validateNewTelecomSchedule(vm.move)">
                    ({{ vm.move.telecomInstallationScheduleByAdmin.date | formatDate }} -
                    {{ vm.move.telecomInstallationScheduleByAdmin.timeSlot }})
                </div>
            </div>
        </ng-container>

        <div *ngIf="uiSandbox.tabletPortraitUp$ | async">
            <app-button type="button" theme="tertiary" *ngSwitchCase="true" [disabled]="true">{{
                'DASHBOARD.COMPLETE_DATA.TELECOM.CTA.COMPLETE' | translate
            }}</app-button>

            <app-button type="button" *ngSwitchCase="false" (onClick)="goToTelecom()" theme="secondary-outline">{{
                'DASHBOARD.COMPLETE_DATA.TELECOM.CTA.TITLE' | translate
            }}</app-button>
        </div>
    </div>
</div>
            <div *ngIf="uiSandbox.upToAndIncludingPhoneLandscape$ | async">
                <app-button type="button" theme="tertiary" class="u-w100p" *ngSwitchCase="true" [disabled]="true">{{
                    'DASHBOARD.COMPLETE_DATA.TELECOM.CTA.COMPLETE' | translate
                }}</app-button>

                <app-button type="button" *ngSwitchCase="false" class="u-w100p" (onClick)="goToTelecom()" theme="secondary-outline">{{
                    'DASHBOARD.COMPLETE_DATA.TELECOM.CTA.TITLE' | translate
                }}</app-button>
            </div>
        </div>
    `,
    styleUrls: ['./complete-data-telecom.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompleteDataTelecomComponent {
    constructor(
        public moveSandbox: MoveSandbox,
        public uiSandbox: AppUiSandbox,
        public router: Router,
        public telecomSandbox: TelecomSandbox
    ) {}

    public goToTelecom(): void {
        this.moveSandbox.telecomInstallationCompleteOnce$.subscribe((telecomInstallationComplete) => {
            if (telecomInstallationComplete) {
                this.router.navigateByUrl(`/${Navigation.Complete}/telecom/phone-numbers`);
            } else {
                this.router.navigateByUrl(`/${Navigation.Complete}/telecom/telecom-installation`);
            }
        });
    }
}
